import React from 'react';
import Footer from './Footer';
import Navbar from './Navbar1';

function Disclaimer() {
    return (
        <div>
            <Navbar />
            <div className="relative max-w-4xl mx-auto ">
                <div className="relative z-10">
                    <div className="container mx-auto p-6">
                        <section tabIndex="-1" className="max-w-4xl mx-auto">
                            <div className="relative ">
                                <div className="relative">
                                    <div>
                                        <h1 className="text-3xl font-bold text-black mb-2">
                                            PAWFECT
                                        </h1>
                                        <h1 className="text-3xl font-bold text-black mb-2">
                                            DISCLAIMER
                                        </h1>
                                    </div>
                                    <div>
                                        <p className="text-lg py-11">
                                            "By using PAWFECT, you agree to the following: ensure your pet's vaccinations comply with local regulations before interactions, take sole responsibility for your pet's behavior and health during app-facilitated interactions, verify your pet's genetics before pairing (as we don't validate genetic backgrounds), and abide by local pet ownership laws. The app and its company bear no liability for incidents during interactions."
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </div>

    );
}

export default Disclaimer;
